/**
 * Tiny runtime registry that stores the current user's custom template
 * variables so any component (HighlightedVariableEditor, suggestVariable…)
 * can look them up synchronously without prop drilling.
 *
 * Updated by `useCustomVariables` whenever the list refetches.
 */

export interface RegisteredCustomVariable {
  key: string;
  label: string;
  default_value?: string | null;
}

let registry: RegisteredCustomVariable[] = [];
const listeners = new Set<() => void>();

export function setCustomVariables(vars: RegisteredCustomVariable[]) {
  registry = vars.map(v => ({ key: v.key, label: v.label, default_value: v.default_value ?? null }));
  listeners.forEach(l => l());
}

export function getCustomVariables(): RegisteredCustomVariable[] {
  return registry;
}

/** Subscribe to registry changes. Returns an unsubscribe function. */
export function subscribeCustomVariables(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}